export const CARD_BODY_COLUMN_DESCRIPTION = 'col-sm-12 col-md-12 col-lg-9 card-body-column'
